var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_189986",
    "data-name": "Group 189986",
    transform: "translate(-722 -375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-download",
    "data-name": "Icon feather-download",
    transform: "translate(725.5 378.957)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43002",
    "data-name": "Path 43002",
    d: "M15.744,22.5V25a1.249,1.249,0,0,1-1.249,1.249H5.749A1.249,1.249,0,0,1,4.5,25V22.5",
    transform: "translate(0 -10.504)",
    fill: "none",
    stroke: "#6a3089",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43003",
    "data-name": "Path 43003",
    d: "M10.5,15l3.123,3.123L16.746,15",
    transform: "translate(-3.501 -6.127)",
    fill: "none",
    stroke: "#6a3089",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43004",
    "data-name": "Path 43004",
    d: "M18,12V4.5",
    transform: "translate(-7.878)",
    fill: "none",
    stroke: "#6a3089",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.9933e5c0bd25d1ea5467e7a6411e3c70.svg";
export { ForwardRef as ReactComponent };